exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-select-toggle>.caret{pointer-events:none}.select2-container-active .select2-choice,.select2-drop-active{border-color:#55c0ab}.select2-results .select2-highlighted{background-color:#55c0ab;color:#fff;border-radius:3px}.ui-select-choices-row:hover{background-color:#32cd32!important;color:#fff;border-radius:3px;background-image:linear-gradient(90deg,#4fb7af,#267dc9)}", ""]);

// exports
